import React, { useState } from "react";
import FooterBottom from "./FooterBottom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import { BASE_URL } from "../../../Service";

const Footer = () => {
  const services = useSelector((state) => state.data.service);
  const siteData = useSelector(
    (state) => state.data.sitesetting?.siteSetting?.[0]?.data
  );

  const handleClick = () => {
    window.scroll(0, 0);
  };

  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState("");

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }

    try {
      setSubmitting(true);
      const response = await fetch(`${BASE_URL}/api/v1/newsLetters/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          domain: "techniajz.com",
        },
        body: JSON.stringify({ email }),
      });

      const result = await response.json();

      if (response.ok) {
        setMessage(
          "Thank you for subscribing! You've successfully joined our newsletter."
        );
        setSuccess(true);
        setEmail("");

        setTimeout(() => {
          setMessage("");
          setSuccess("");
        }, 3000);
      } else {
        setMessage(result.message || "Failed to subscribe Newsletter");
        setSuccess(false);
      }
    } catch (error) {
      setMessage("Something went wrong.");
      setSuccess(false);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <footer id="extraP" className="rs-footer">
      <div className="footer-top">
        <div className="container">
          <div className="row" style={{ padding: "0 18px" }}>
            <div className="col-xl-3 col-lg-3 col-md-4">
              <div className="footer-logo">
                <a href="/">
                  <img src={siteData.logos[0]} alt="Logo" />
                </a>
              </div>
              <div className="textwidget pb-30">
                <p>{siteData?.description}</p>
              </div>
              {/* <ul className="footer-social md-mb-30">
                <li>
                  <a
                    href={siteData.socialLinks.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://in.pinterest.com/techniajz/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-pinterest"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/TechniAjz"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/techniajz/?igsh=MTl3Z3pnZHF4cmpneA%3D%3D#"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
              </ul> */}

              <ul className="footer-social md-mb-30">
                {siteData.socialLinks?.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className={`fa fa-${link.platform.toLowerCase()}`}></i>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-lg-3 col-md-12 col-sm-12 pl-44 md-pl-14 md-mb-30">
              <h3 className="widget-title">IT Services</h3>
              {/* <ul className="site-map">
                <li>
                  <Link
                    // href="/service/software-development"
                    to={`/service/${service._id}`}
                  >
                    Custom Web Development
                  </Link>
                </li>
                <li>
                  <a href="/service/Web-development">Mobile App Development</a>
                </li>
                <li>
                  <a href="/service/analytic-solutions">
                    Wordpress Customization
                  </a>
                </li>
                <li>
                  <a href="/service/cloud-and-devOps">Server Management</a>
                </li>
                <li>
                  <a href="/service/project-design">Quality Assurance</a>
                </li>
                <li>
                  <a href="/service/project-design">Security Optimization</a>
                </li>
              </ul> */}
              {services && services.length > 0 && (
                <ul className="site-map">
                  {services.map((service) => (
                    <li key={service._id}>
                      <Link
                        to={`/service/${service._id}`}
                        onClick={handleClick}
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="col-lg-3 col-md-12 col-sm-12 md-mb-30">
              <h3 className="widget-title">Contact Info</h3>
              <ul className="address-widget">
                <li>
                  <i className="flaticon-location"></i>
                  <div className="desc">{siteData.addresses}</div>
                </li>
                <li>
                  <i className="flaticon-call"></i>
                  <div className="desc">
                    <a href="/about">{siteData.phones}</a>
                  </div>
                </li>
                <li>
                  <i className="flaticon-email"></i>
                  <div className="desc">
                    <a
                      href="https://mail.google.com/mail/?view=cm&fs=1&to=info@techniajz.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {siteData.email}
                    </a>
                  </div>
                </li>
                <li>
                  <i className="flaticon-clock"></i>
                  <div className="desc">
                    Opening Hours: 10 AM - 7PM
                    <br />
                    Saturday , Sunday - Closed
                  </div>
                </li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-12 col-sm-12">
              <h3 className="widget-title">Newsletter</h3>
              <p className="widget-desc">
                We denounce with righteous and in and dislike men who are so
                beguiled and demo realized.
              </p>
              <div
                className="newsletter-area pt-75 pb-40"
                style={{ paddingTop: "30px" }}
              >
                <div className="single-newsletters">
                  <form>
                    <div className="newsletter-form">
                      <div style={{ position: "relative" }}>
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Your email"
                          style={{
                            border: "none",
                            width: "91%",
                            fontSize: "13px",
                            padding: "16px 60px 16px 20px",
                            margin: "0",
                            color: "#0a0a0a",
                            overflow: "hidden",
                            borderRadius: "30px 0 0 30px",
                            background: "#fff",
                            boxShadow: "0 0 25px #eee",
                            outline: "none",
                          }}
                        />
                        <button
                          className="button-with-icon"
                          disabled={submitting}
                          onClick={handleNewsletterSubmit}
                          style={{
                            width: "max-content",
                            position: "absolute",
                            top: "1px",
                            right: "1px",
                            bottom: "1px",
                            backgroundImage:
                              "linear-gradient(90deg, #03228f, #0e73e4)",
                            borderRadius: "50%",
                            padding: "28px 28px",
                            fontSize: "0",
                            border: "none",
                            outline: "none",
                          }}
                        ></button>
                      </div>
                    </div>

                    {submitting ? (
                      <div style={{ color: "#0849b8", marginTop: "10px" }}>
                        Submitting...
                      </div>
                    ) : (
                      message && (
                        <div
                          style={{
                            color: success ? "green" : "red",
                            marginTop: "10px",
                          }}
                        >
                          {message}
                        </div>
                      )
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterBottom />
    </footer>
  );
};

export default Footer;
